import { Service, inject } from '@angular/core';
import { getAnonUserId } from '@app/helpers/fingerprinting';
import { ApiService } from './api.service';
import Cookies from 'js-cookie';

const AB_TEST_COOKIE_PREFIX = 'mobi_ab_';
const COOKIE_EXPIRE_DAYS = 365;

@Service()
export class ABTestingService {
  #api = inject(ApiService);
  #userIdCache: string | null = null;

  /**
   * Get the user ID for A/B testing (uses fingerprinting)
   */
  async getUserId(): Promise<string | null> {
    if (this.#userIdCache) {
      return this.#userIdCache;
    }

    try {
      this.#userIdCache = await getAnonUserId();
      return this.#userIdCache;
    } catch (error) {
      console.error('Failed to get user ID for A/B testing:', error);
      return null;
    }
  }

  /**
   * Get assignment from local cookie
   */
  getLocalAssignment(nodeId: string): 'A' | 'B' | null {
    const cookieName = `${AB_TEST_COOKIE_PREFIX}${nodeId}`;
    const value = Cookies.get(cookieName);
    return value === 'A' || value === 'B' ? value : null;
  }

  /**
   * Store assignment in local cookie
   */
  setLocalAssignment(nodeId: string, variant: 'A' | 'B'): void {
    const cookieName = `${AB_TEST_COOKIE_PREFIX}${nodeId}`;
    Cookies.set(cookieName, variant, {
      expires: COOKIE_EXPIRE_DAYS,
      sameSite: 'Strict',
    });
  }

  /**
   * Get or create A/B test assignment for a node
   */
  async getAssignment(nodeId: string, splitRatio: number): Promise<'A' | 'B'> {
    const localAssignment = this.getLocalAssignment(nodeId);
    if (localAssignment) return localAssignment;

    const userId = await this.getUserId();

    if (!userId) 'A';

    try {
      const result = await this.#api.httpPost(`/ab/assignment`, {
        nodeId,
        userId,
        splitRatio,
      });

      const variant = result.variant as 'A' | 'B';

      this.setLocalAssignment(nodeId, variant);

      return result.variant as 'A' | 'B';
    } catch (error) {
      console.error('Failed to get A/B test assignment:', error);
      return 'A';
    }
  }
}
